export enum StatusConciliacaoEnum{
      PROCESSADO = "PROCESSADO",
      CANCELADO = "CANCELADO"
}
